export const STAKING_STATUS = Object.freeze({
  PENDING: "pending",
  HOLDING: "holding",
  CLAIMED: "claimed",
  CLAIM_FAILED: "claim_failed",
  REDEEMED: "redeemed",
  FAILED: "failed",
  EARLY_REDEEMED: "early_redeemed",
  CLAIM_IN_PROGRESS: "claim_in_progress",
});

export const STAKING_STATUS_LABEL_MAP = {
  [STAKING_STATUS.PENDING]: "Stake pending",
  [STAKING_STATUS.HOLDING]: "Staking",
  [STAKING_STATUS.FAILED]: "Stake failed",
  [STAKING_STATUS.EARLY_REDEEMED]: "Early redeemed",
  [STAKING_STATUS.REDEEMED]: "Staking finished",
  [STAKING_STATUS.CLAIM_IN_PROGRESS]: "Claim in progress",
  [STAKING_STATUS.CLAIMED]: "Claim success",
  [STAKING_STATUS.CLAIM_FAILED]: "Claim failed",
};
